@for (position of toastPositions(); track position) {
  <div
    class="fixed z-[8000] flex w-full max-w-xs flex-col gap-2"
    [ngClass]="{
      'right-4 top-4': position === 'top-right',
      'left-1/2 top-4 -translate-x-1/2': position === 'top-center',
      'left-4 top-4': position === 'top-left',
      'bottom-4 right-4': position === 'bottom-right',
      'bottom-4 left-1/2 -translate-x-1/2': position === 'bottom-center',
      'bottom-4 left-4': position === 'bottom-left',
    }"
  >
    @for (alert of toasts()[position]; track trackByFn($index, alert)) {
      <div
        class="group relative flex w-full max-w-lg flex-col gap-2 rounded-lg bg-white p-4 shadow-[0_4px_8px_rgba(0,0,0,0.1)] transition-all duration-300 ease-in-out"
        [id]="alert.id()"
        [style.z-index]="getToastZIndex($index, toasts()[position])"
        [@slideInOutAnimation]="alert.animation() === 'slide' ? alert.animationState() : ''"
        (@slideInOutAnimation.done)="animationHandler(alert)"
        [@fadeInOutAnimation]="alert.animation() === 'fade' ? alert.animationState() : ''"
        (@fadeInOutAnimation.done)="animationHandler(alert)"
        (mouseenter)="onMouseEnter(alert)"
        (mouseleave)="onMouseLeave(alert)"
        (touchstart)="onTouchStart($event, alert)"
        (touchmove)="onTouchMove($event, alert)"
        (touchend)="onTouchEnd($event, alert)"
        role="alert"
        aria-live="assertive"
      >
        <div class="flex items-center gap-2">
          <palantir-icon
            [name]="alert.icon() ?? themes[alert.theme()].icon"
            [style.color]="themes[alert.theme()].color"
          />

          @if (alert.messageIsHtml()) {
            <palantir-text type="text" [innerHTML]="alert.message()"></palantir-text>
          } @else {
            <palantir-text type="text">{{ alert.message() }}</palantir-text>
          }

          @let alertCallToAction = alert.callToAction();
          @if (alertCallToAction) {
            <palantir-button
              [attr.theme]="alertCallToAction.button?.theme || 'outline'"
              [attr.variant]="alertCallToAction.button?.variant || 'primary'"
              layout="icon"
              [icon]="alert.callToActionLoading() ? 'loading-outline' : alertCallToAction.icon"
              (click)="executeHandler(alert, $event)"
              [palantirTooltip]="alertCallToAction.label"
              [palantirTooltipDelay]="300"
              size="xs"
              class="ml-auto min-h-8 min-w-8"
            />
          }
        </div>

        @if (alert.progress() !== null && alert.theme() !== 'success') {
          @let alertProgress = alertProgressAsNumber(alert.progress());
          @if (alertProgress !== null && alert.theme() !== 'success') {
            <div class="grid min-w-72 grid-cols-[auto_1fr] items-center gap-2 rounded-full">
              @if (alertProgress! < 100 && alert.estimatedTime()) {
                <palantir-text size="xs" type="description">
                  ({{ alert.estimatedTime() ?? '' }})
                </palantir-text>
              }

              <palantir-progress-bar
                class="w-full rounded-full"
                [progress]="alertProgress || 1"
                mode="determinate"
              />
            </div>
          }

          @let alertProgressIsIndeterminate = alertProgressAsString(alert.progress());

          @if (alertProgressIsIndeterminate === 'indeterminate') {
            <div class="grid grid-cols-[1fr] items-center gap-2 rounded-full">
              <palantir-progress-bar class="rounded-full" mode="indeterminate" />
            </div>
          }
        }

        @if (alert.dismissible() && alert.animationState() === 'stable') {
          <div
            class="absolute -right-8 top-1/2 -translate-x-1/2 -translate-y-1/2 transform rounded-full opacity-0 transition-all group-hover:-right-14 group-hover:opacity-100"
          >
            <palantir-button
              (click)="removeHandler(alert)"
              [palantirTooltip]="'Fechar'"
              [palantirTooltipDelay]="300"
              aria-label="Fechar notificação"
              layout="icon"
              icon="close-outline"
              theme="outline"
              variant="negative"
              size="xs"
              class="min-h-8 min-w-8 bg-white"
            />
          </div>
        }
      </div>
    }
  </div>
}
